import {
  Component,
  Output,
  EventEmitter,
  Inject,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { PagamentoSaidaService } from 'src/app/services/PagamentoSaida/pagamentoSaida.service';
import { ICreatePagamentoSaida } from 'src/app/services/PagamentoSaida/pagamentoSaida.model';
import { Location } from '@angular/common';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-modal-pagamento-saida',
  templateUrl: './modal-pagamento-saida.component.html',
  styleUrls: ['./modal-pagamento-saida.component.scss']
})
export class ModalPagamentoSaidaComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isLoading: boolean = false;
  descontoAgendamento = 0;
  guid = generateUUID();

  pagamentoOptions = [
    { name: 'Cartão de Crédito', value: 1 },
    { name: 'Cartão de Débito', value: 19 },
    { name: 'Pix', value: 27 },
    { name: 'Dinheiro', value: 9 },
    { name: 'A Prazo', value: 28 }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPagamentoSaidaComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private pagamentoSaidaService: PagamentoSaidaService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.getDesconto();

    this.form.get('VL_ACRM')?.valueChanges.subscribe(() => {
      this.handleAcrDescontoChange();
    });

    this.form.get('VL_DSCT')?.valueChanges.subscribe(() => {
      this.handleAcrDescontoChange();
    });
  }

  handleAcrDescontoChange(): void {
    this.calcValores();
  }

  ngOnDestroy(): void {
    this.form.reset();
  }

  initForm(): FormGroup {
    return this.fb.group({
      FK_GATE_ENTR: [null, [Validators.required]],
      FK_SRVC_ENTR_LIST: this.fb.array([]),
      ServicoPagamentoTipoValor: this.fb.array([]),
      VL_DSCT: [0],
      VL_ACRM: [0],
      NM_TIPO_PGMT: [''],
      NU_TIPO_PGMT: [0],
      VL_PGMT_SAID: [0],
      VL_TOTL: [0],
      VL_REST: [0]
    });
  }

  onConfirmar(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.pagamentoSaidaService
      .CreatePagamentoSaida(payload, this.guid)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  onCancelar(): void {
    this.dialogRef.close();
  }

  createPayload(): ICreatePagamentoSaida {
    const FK_FUNC_OPER = Number(localStorage.getItem('id'));

    const servicosList = this.ServicoPagamentoTipoValor?.value?.map((item: any) => ({
      NU_TIPO_PGMT: item?.NU_TIPO_PGMT,
      VL_PGMT_SAID: item?.VL_PGMT_SAID
    })) || [];

    const idServicosList = this.form.get('FK_SRVC_ENTR_LIST') as FormArray;
    let idList = idServicosList?.value || [];
    idList = Array.from(new Set(idList)); // Ensure unique values

    return {
      VL_ACRM: this.form.get('VL_ACRM')?.value,
      VL_DSCT: this.form.get('VL_DSCT')?.value,
      FK_FUNC_OPER: FK_FUNC_OPER,
      FK_GATE_ENTR: this.form.get('FK_GATE_ENTR')?.value,
      FK_SRVC_ENTR_LIST: idList,
      ServicoPagamentoTipoValor: servicosList,
      FL_COBRAR_PRE_PTIO: !!this.data.FL_COBRAR_PRE_PTIO,
      VL_PRE_PTIO: this.data.FL_COBRAR_PRE_PTIO ? Number(this.data.VL_PRE_PTIO || 0) : 0
    };
  }

  addPagamento() {
    // if (this.blockAdicionarPagamento) return;

    const valorRestante = this.form.get('VL_REST')?.value;
    const valorParaAdicionar = this.form.get('VL_PGMT_SAID')?.value;

    if (valorParaAdicionar > valorRestante) {
      this.swalAlert.showAlert(
        'Atenção!',
        'O valor do pagamento não pode ser maior que o valor restante!',
        'warning',
        true,
        false,
        undefined,
        () => {}
      );
      return;
    }

    const pagamentoAtual = Number(this.form.get('NU_TIPO_PGMT')?.value);
    const pagamento = this.pagamentoOptions.find(
      option => Number(option.value) === pagamentoAtual
    );
    if (pagamento) {
      const pagamentoForm = this.fb.group({
        NM_TIPO_PGMT: [pagamento.name],
        NU_TIPO_PGMT: [pagamento.value, Validators.required],
        VL_PGMT_SAID: [
          this.form.get('VL_PGMT_SAID')?.value,
          Validators.required
        ]
      });
      this.ServicoPagamentoTipoValor.push(pagamentoForm);
    }
    this.calcValorRestante();
  }

  removePagamento(index: number) {
    this.ServicoPagamentoTipoValor.removeAt(index);
    this.calcValorRestante();
  }

  getDesconto(): void {
    const FK_GATE_ENTR = this.data.FK_GATE_ENTR;
    this.isLoading = true;
    this.pagamentoSaidaService
      .GetDescontoAgendamentoByGateEntrada(FK_GATE_ENTR)
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.descontoAgendamento = res.VL_DSCT_AGND;
          //this.form.controls['VL_DSCT'].setValue(VL_DSCT_AGND);
          this.calcValores();
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  calcValores(): void {
    const acrescimo = Number(this.form.get('VL_ACRM')?.value || 0);
    const desconto = Number(this.form.get('VL_DSCT')?.value || 0);

    const valorCalculado =
      this.data.VL_TOTL + acrescimo - desconto - this.descontoAgendamento;

    // garante mínimo de 0
    const valorTotalCorrigido = Math.max(valorCalculado, 0);

    this.form.get('FK_GATE_ENTR')?.setValue(this.data.FK_GATE_ENTR);
    this.form.get('VL_TOTL')?.setValue(valorTotalCorrigido);

    // Rebuild da lista (clear evita duplicar IDs a cada mudança de acréscimo/desconto).
    this.SrvcEntrList.clear();
    (this.data.FK_SRVC_ENTR_LIST || []).forEach((id: number) => {
      this.SrvcEntrList.push(this.fb.control(id));
    });

    this.calcValorRestante();
  }

  calcValorRestante(): void {
    const valorTotal = Number(this.form.get('VL_TOTL')?.value || 0);

    const valorAdicionado = this.ServicoPagamentoTipoValor.value.reduce(
      (acc: number, x: any) => acc + Number(x.VL_PGMT_SAID || 0),
      0
    );

    let valorRestante = Number((valorTotal - valorAdicionado).toFixed(2));

    // impede valor negativo
    valorRestante = Math.max(valorRestante, 0);

    this.form.controls['VL_REST'].setValue(valorRestante);
    // Default do input acompanha o restante (no início = Total).
    this.form.controls['VL_PGMT_SAID'].setValue(valorRestante, {
      emitEvent: false
    });
  }

  // activateRoute(): void {
  //   this.getDesconto();
  // }

  get SrvcEntrList(): FormArray {
    return this.form.get('FK_SRVC_ENTR_LIST') as FormArray;
  }

  get ServicoPagamentoTipoValor(): FormArray {
    return this.form.get('ServicoPagamentoTipoValor') as FormArray;
  }

  onChangePagamento(event: any) {
    this.form.get('NU_TIPO_PGMT')?.setValue(event);
    const valorRestante = Number(this.form.get('VL_REST')?.value || 0);
    if (event && valorRestante > 0) {
      this.form.get('VL_PGMT_SAID')?.setValue(valorRestante, { emitEvent: false });
    }
  }

  disableConfirmar(): boolean {
    const valorRestante = this.form.get('VL_REST')?.value;
    const temServicos = this.SrvcEntrList.length > 0;
    const temPrePatio = !!this.data.FL_COBRAR_PRE_PTIO;
    if (this.form.valid && (temServicos || temPrePatio) && valorRestante === 0) {
      return false;
    }
    return true;
  }
}
